export default __webpack_public_path__ + "static/media/storiesmt.a235c78b.png";